import { Button, IconButton } from "@mui/material";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import dayjs from "configs/dayjs.config";

import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";

export const LotFields = ({
  index,
  lotDetails,
  setLotDetails,
  handleDeleteLotProcessing,
  handleDeletePart,
  handleAddLotProcessing,
  partNames,
  setPartNames,
}) => {
  const [shouldRerender, setShouldRerender] = useState(false);
  const [partTempName, setPartTempName] = useState("");

  useEffect(() => {
    setPartTempName(partNames[index]);
  }, [partNames]);

  const handleQuantityChange = (e, i) => {
    const temp = lotDetails[index];
    if (temp?.[i]) {
      temp[i] = {
        ...temp[i],
        [e.target.name]: e.target.value,
      };
      let finalValue;
      finalValue = structuredClone(lotDetails);
      finalValue[index] = temp;
      setLotDetails(finalValue);
    }
    setShouldRerender(!shouldRerender);
  };
  const handleDeadlineChange = (newValue, i) => {
    const temp = lotDetails[index];
    if (temp[i]) {
      temp[i] = {
        ...temp[i],
        deadline: new Date(newValue),
      };
      let finalValue;
      finalValue = structuredClone(lotDetails);
      finalValue[index] = temp;
      setLotDetails(finalValue);
    }
    setShouldRerender(!shouldRerender);
  };
  const handlePartNameChange = (e) => {
    setPartTempName(e.target.value);
    let temp = structuredClone(partNames);
    temp[index] = e.target.value;
    setPartNames(temp);
  };
  return (
    <>
      <FlexBox justifyContent="space-between">
        <TextFieldWrapper
          id={"partNo" + (index + 1)}
          name={"partNo" + (index + 1)}
          label={"Part No " + (index + 1)}
          variant="outlined"
          value={partTempName || ""}
          fullWidth
          required
          onChange={handlePartNameChange}
        />
        <Button color="error" onClick={() => handleDeletePart(index)}>
          <RemoveIcon />
        </Button>
      </FlexBox>
      {lotDetails[index]?.map((item, i) => {
        return (
          <FlexBox key={i}>
            <TextFieldWrapper
              id="quantity"
              name="quantity"
              label={`Lot ${i + 1} Quantity`}
              variant="outlined"
              type="number"
              value={lotDetails[index][i]?.quantity || null}
              fullWidth
              required
              onChange={(e) => handleQuantityChange(e, i)}
            />
            <DatePickerWrapper
              label="Delivery Date"
              value={dayjs(lotDetails[index][i]?.deadline) || new Date()}
              onChange={(newValue) =>
                handleDeadlineChange(dayjs(dayjs(newValue)), i)
              }
            />
            <IconButton onClick={() => handleDeleteLotProcessing(index, i)}>
              <RemoveIcon />
            </IconButton>

            {i === lotDetails[index].length - 1 && (
              <IconButton onClick={() => handleAddLotProcessing(index)}>
                <AddIcon />
              </IconButton>
            )}
          </FlexBox>
        );
      })}
    </>
  );
};
